import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M5.25 1.5C4.00736 1.5 3 2.50736 3 3.75V14.25C3 15.4926 4.00736 16.5 5.25 16.5H11.378C11.2951 16.2654 11.25 16.013 11.25 15.75C10.0074 15.75 9 14.7426 9 13.5C9 12.2574 10.0074 11.25 11.25 11.25C11.25 10.0074 12.2574 9 13.5 9C14.0763 9 14.6019 9.21664 15 9.57292V3.75C15 2.50736 13.9926 1.5 12.75 1.5H5.25Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M14.25 11.25C14.25 10.8358 13.9142 10.5 13.5 10.5C13.0858 10.5 12.75 10.8358 12.75 11.25V12.75H11.25C10.8358 12.75 10.5 13.0858 10.5 13.5C10.5 13.9142 10.8358 14.25 11.25 14.25H12.75V15.75C12.75 16.1642 13.0858 16.5 13.5 16.5C13.9142 16.5 14.25 16.1642 14.25 15.75V14.25H15.75C16.1642 14.25 16.5 13.9142 16.5 13.5C16.5 13.0858 16.1642 12.75 15.75 12.75H14.25V11.25Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }